import styled from '@emotion/styled'

const StyledContainer = styled.div`
  display: flex;
  align-items: start;
  padding: 8px;
`

export default StyledContainer
